import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../../avatar/avatar';
import SmartHighlight from '../../algolia_search/smart_highlight';

function NamePhotoTitle({
                          prUser,
                          smallMode,
                        }) {
  let titleHtml = null;
  if (prUser.current_positions && prUser.current_positions[0]) {
    titleHtml = (
      <div className="card-grid-subtitle fw-bold font-size-12px">
        {prUser.current_positions[0].title} at {
        prUser.company_show && (
          <a href={prUser.current_positions[0].company_path}>
            {prUser.current_positions[0].company}
          </a>
        )
      }
        {!prUser.company_show && prUser.current_positions[0].company}
      </div>
    );
  }

  return (
    <>
      <div>
        <div className="float-start pe-2">
          <Avatar
            avatarUrl={prUser.avatar_url}
            avatarLetters={prUser.initials}
            sizeClass={smallMode ? 'avatar-xs' : 'avatar'}
          />
        </div>
        <div>
          <h6 className="mb-0 fw-bold">
            <a href={prUser.pr_user_path}>
              <SmartHighlight attribute="full_name" hit={prUser} />
            </a>
            {prUser.is_self_source && (
              <span className="badge bg-primary self-source-badge ms-1">You</span>
            )}
          </h6>
          {titleHtml}
        </div>
      </div>
      <div className="clearfix mb-2" />
    </>
  );
}

NamePhotoTitle.propTypes = {
  prUser: PropTypes.instanceOf(Object).isRequired,
  smallMode: PropTypes.bool,
};

NamePhotoTitle.defaultProps = {
  smallMode: false,
};

export default NamePhotoTitle;
